import accountActions from './account'
import merchantActions from './merchant'
import payActions from './pay'
import deviceActions from './device'
import productActions from './product'
import surveyActions from './survey'
import plateActions from './plate'
import turnoverActions from './turnover'
import subfoodActions from './subfood'
import fileActions from './file'
import foodActions from './food'
import orderActions from './order'
import excelActions from './excel'
import openPlatformActions from './open_platform'
import faceActions from './face'
import discountActions from './discount'
import priorityActions from './priority'
import h5Actions from './h5'

export default {
  ...accountActions,
  ...merchantActions,
  ...payActions,
  ...deviceActions,
  ...productActions,
  ...surveyActions,
  ...plateActions,
  ...turnoverActions,
  ...subfoodActions,
  ...fileActions,
  ...foodActions,
  ...orderActions,
  ...excelActions,
  ...openPlatformActions,
  ...faceActions,
  ...discountActions,
  ...priorityActions,
  ...h5Actions
}



// WEBPACK FOOTER //
// ./src/vuex/actions/index.js